import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead, Checkbox,
    TableBody, FormControlLabel,
    TableCell
    ,TableContainer,
          Paper,
} from "@material-ui/core";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import { Card, Box } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService"
import TeacherNotesService from "./Locality/Service/teacherNotesService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function TeacherNotes() {
    const tableHeaders = ['Student', 'Class', 'Section', 'Notes', 'Edit', 'Delete'];

    const classes = useStyles();
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [teacherNotesList, setTeacherNotesList] = useState([]);
    const [formData, setFormData] = useState("");
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const current = new Date();
    var [classId, setClassId] = useState("");
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    var [dateValue, setDateValue] = useState(date);

    const [sectionList, setSectionList] = useState([]);
    const [teacherNotes, setTeacherNotes] = useState({
        classId: '',
        sectionId: '',
        notes: '',
        studentId: '',
    });

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
        studentId: Yup.string().required('Student Name is required'),
        notes: Yup.string().required('notes is required'),
    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    //    useEffect(() => {
    //         // getStudentList();
    //         getSpecialObservationList();
    //         getAddClassList();
    //         return () => {
    //             setTeacherIdList([]);
    //             setTeacherList([]);
    //             setAddClassList([]);
    //             setStudentList([]);
    //             setSpecialObservationList([]);
    //             // setClassNameList([]);
    //         }
    //     }, []);
    useEffect(() => {
        getStudentList();
         getTeacherNotesList();
        getAddClassList();
        return () => {
            setStudentList([]);
            setAddClassList([]);
        }
    }, []);
    const getTeacherNotesList = () => {
        TeacherNotesService.getAllTeacherNotes().then((res) => {
            setTeacherNotesList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    const toLowerSafe = (value) => {
  return value ? value.toLowerCase() : '';
};
    const handleOpen = () => {
        if (!teacherNotes._id && userDetails.role === "TEACHER" && (userDetails.classId || userDetails.sectionId)) {
            setTeacherNotes(prev => ({
                ...prev,
                classId: userDetails.classId || prev.classId,
                sectionId: userDetails.sectionId || prev.sectionId,
            }));
        }
        setOpen(true);
    };
    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        }).then((res) => {
            let list = Array.isArray(res) ? res : [];
            // if (userDetails.role === "TEACHER" && userDetails.sectionId) {
            //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
            // }
            setSectionList(list);
        }).catch(() => setSectionList([]));
    };

    const getAddClassList = (event) => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = res;
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                list = res.filter((r) => r._id === userDetails.classId);
            }
            setAddClassList(list);
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                setClassId(userDetails.classId);
                getSectionListByClass(userDetails.classId);
                getStudentList({ target: { value: userDetails.classId } }, userDetails.sectionId || undefined);
            } else {
                setClassId("");
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const editTeacherNotes = (teachernotes) => {
        teachernotes.classId = teachernotes.classId ? teachernotes.classId._id : '';
        teachernotes.sectionId = teachernotes.sectionId ? (teachernotes.sectionId._id || teachernotes.sectionId) : '';
        teachernotes.studentId = teachernotes.studentId ? teachernotes.studentId._id : '';
        setTeacherNotes(teachernotes);
        getSectionListByClass(teachernotes.classId);
        handleOpen(true);
    }
   

    const deleteTeacherNotes = (notesdelete) => {
        if (notesdelete) {
            TeacherNotesService.deleteTeacherNotes(notesdelete).then((res) => {

                getTeacherNotesList()
            }).catch((err) => {
            });
        }
    }
    const handleChangeImage = (evt) => {
        console.log("Uploading");
        var file = evt.target.files[0];
        let data = new FormData();
        data.append('image', file);
        setFormData(data)
        console.log("Uploaded");
    }

    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = event?.target?.value ?? classId ?? "";
        if (!selectedClassId) return;

        const getSpeList = { classId: selectedClassId };
        const sectionIdToUse = overrideSectionId !== undefined ? overrideSectionId : (formik.values.sectionId || userDetails.sectionId);
        if (sectionIdToUse) getSpeList.sectionId = sectionIdToUse;

        StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
            .then((res) => {
                const studentDetails = res.map(res => ({
                    _id: res._id,
                    studentName: `${res.firstName} ${res.lastName}`,
                    status: true
                }));
                setStudentList(studentDetails);
            })
            .catch((err) => {
                console.error("Error fetching students:", err.message);
            });
    };


    const formik = useFormik({
        initialValues: teacherNotes,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.teacherId = userDetails.teacherId || userDetails._id;
            values.userId = userDetails._id || userDetails._id;
            values.sectionId = values.sectionId || undefined;

            if (teacherNotes._id) {
                TeacherNotesService.upadeTeacherNotes(values)
                    .then((res) => {
                        handleClose();
                        getTeacherNotesList();
                        resetForm();
                        alert("Updated Successfully.");
                    })
                    .catch((err) => {
                        alert(err.response?.data?.message || "Update failed");
                    });
            } else {
                debugger
                TeacherNotesService.creteTeacherNotes(values)
                    .then((res) => {
                        getTeacherNotesList();
                        resetForm();
                        handleClose();
                        alert("Added Successfully.");
                    })
                    .catch((err) => {
                        alert(err.response?.data?.message || "Creation failed");
                    });
            }
        },
    });

    const handleCheck = (student, movableKey) => {

        // Update the student's sound locally
        const updatedStudent = {
            ...student,
            movable: {
                ...student.movable,
                [movableKey]: !student.movable[movableKey],
            },
        };

        // Update the student list state
        const updatedList = studentList.map((s) =>
            s._id === student._id ? updatedStudent : s
        );
        setStudentList(updatedList);

        // Call API to update the student
        StudentService.upadeStudent(updatedStudent)
            .then((res) => {
                // Optionally refresh the student list if the API response provides updated data
                // getStudentList();
            })
            .catch((err) => {
                console.error(err.response?.data?.message || "Error updating student");
            });
    };

    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {
            "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
            "date": dateValue
        }
        TeacherNotesService.creteMovable(keys).then((res) => {
            setDateValue("");
            setStudentList([]);
            alert(" Attendence Successfully.");
        }).catch((err) => {

            alert(err.response.data.message);
        });
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={10}>
                    <PageTitle title="Notes For Report"
                        button={<Button
                            variant="contained" onClick={() => handleOpen(true)}
                            size="medium"
                            color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Notes
                        </Button>}
                    />

                </Grid>

            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {teacherNotesList.map((teacherNotes) => (
                                    <TableRow key={teacherNotes._id}>
                                        <TableCell className="pl-3 fw-normal" >
                                            {teacherNotes.studentId ? teacherNotes.studentId.firstName : ""}&nbsp;
                                            {teacherNotes.studentId ? teacherNotes.studentId.lastName : ""}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >{teacherNotes.classId ? teacherNotes.classId.className : ''}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{teacherNotes.sectionId ? teacherNotes.sectionId.sectionName : '-'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{teacherNotes.notes}</TableCell>
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editTeacherNotes(teacherNotes)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteTeacherNotes(teacherNotes)} />
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                                                                            </TableContainer >
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 50, 100, 500, 1000]}
                            count={teacherNotesList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Notes</DialogTitle>


                <DialogContent style={{ width: 345 }}>
                    <FormControl className={classes.formControl} fullWidth="true"
                    >
                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="classId"
                            label="selectClass"
                            value={formik.values.classId}
                            onChange={e => {
                                formik.setFieldValue('sectionId', '');
                                formik.handleChange(e);
                                getSectionListByClass(e.target.value);
                                getStudentList(e, undefined);
                            }}


                            error={formik.touched.classId && Boolean(formik.errors.classId)}
                            helperText={formik.touched.classId && formik.errors.classId}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>

                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}

                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth style={{ marginTop: 8 }}>
                        <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                        <Select
                            labelId="section-select-label"
                            id="sectionId"
                            name="sectionId"
                            value={formik.values.sectionId || ''}
                            onChange={(e) => {
                                formik.handleChange(e);
                                if (formik.values.classId) {
                                    getStudentList(
                                        { target: { value: formik.values.classId } },
                                        e.target.value || undefined
                                    );
                                }
                            }}
                            disabled={!formik.values.classId || sectionList.length === 0}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {sectionList.map(({ _id, sectionName }) => (
                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" fullWidth>
                        <InputLabel id="studentName">Student Name</InputLabel>
                        <Select

                            labelId="studentName"
                            id="studentName"
                            label="Student Name"
                            name="studentId"
                            value={formik.values.studentId}

                            onChange={formik.handleChange}
                            error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                            helperText={formik.touched.studentId && formik.errors.studentId}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {studentList.map(({ index, _id, studentName }) => (
                                <MenuItem key={index} value={_id}>{studentName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField fullWidth
                        margin="dense"
                        id="notes"
                        name="notes"
                        label="Notes"
                        type="text"
                        variant="standard"
                        value={formik.values.notes}
                        onChange={formik.handleChange}
                        error={formik.touched.notes && Boolean(formik.errors.notes)}
                        helperText={formik.touched.notes && formik.errors.notes}
                    />





                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        type="submit" onClick={formik.handleSubmit}
                    // onClick={test}
                    >Add</Button>
                </DialogActions>

            </Dialog>
        </>

    );
}


